export default __webpack_public_path__ + "static/media/330.366aa73b.gif";